import { useTranslation } from "react-i18next";

import { cn } from "~/components/ui/cn";
import { PackageIcon } from "~/components/ui/icons/package";
import { OrderTagReship } from "~/graphql/graphql-new.gen";

import { OrderBadge } from "../order-status-badge/order-badge";
import { getOrderReshipLabelFromTag } from "../order-status-badge/order-reship-badge";

export const OrderReshipBadge: React.FC<{
  isCancelled?: boolean;
  tag: OrderTagReship;
}> = ({ tag, isCancelled }) => {
  const { t } = useTranslation();

  if (tag === OrderTagReship.None) return null;

  return (
    <OrderBadge variant="filled" intent="bold">
      <div className="flex items-center gap-x-1">
        <PackageIcon className="size-3.5" />

        <span className={cn({ "line-through": isCancelled })}>
          {getOrderReshipLabelFromTag(tag, t)}
        </span>
      </div>
    </OrderBadge>
  );
};
